import script from "./TopIdleMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./TopIdleMobile.vue?vue&type=script&setup=true&lang=js"

import "./TopIdleMobile.vue?vue&type=style&index=0&id=147b965e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-147b965e"]])

export default __exports__